import React, { Component } from 'react';
import PatientDetails from './PatientDetails';
import CaseReport from './CaseReport';
import Comments from './Comments';
import TSAArmPosition from './TSAArmPosition';
import TSAComponents from './TSAComponents';
export default class TSASummary extends Component {
	render() {
		const { caseData, isLoading, handleNoteSubmit, notesError, notesSaved, isReadOnlyNotes, handleNotesInputChange, getUserRoleType, caseId } = this.props;
		const caseDetails = caseData && caseData.caseDetails ? caseData.caseDetails : '';
		const cartDetails = caseData && caseData.cartDetails ? caseData.cartDetails : '';
		const operativeApproach = caseDetails?.operativeApproach?.toString()?.toLowerCase() || 'reverse';
		const operativeSide = caseDetails?.operativeSide?.toString()?.toLowerCase() || 'right';
		const caseIntraOp = caseData && caseData.caseIntraOp ? caseData.caseIntraOp : null;

		return (
			<>
				<div className="case-details-container tsa-container" data-testid="tsa-summary">
					{/* Case details left part start */}
					<div className="case-details-left">
						{/* Patient block starts */}
						<div className="case-details-left-blocks">
							<PatientDetails caseDetails={caseDetails} getUserRoleType={getUserRoleType} />
						</div>

						{/* Case Report */}
						<div className="case-details-left-blocks">
							<CaseReport cartDetails={cartDetails} caseDetails={caseDetails} caseIntraOp={caseIntraOp} operativeApproach={operativeApproach} />
						</div>
					</div>

					<div className="case-details-right">
						{/* Alignment */}
						<div className="case-details-right-blocks">
							<TSAArmPosition caseDetails={caseDetails} caseIntraOp={caseIntraOp} operativeApproach={operativeApproach} operativeSide={operativeSide} />
						</div>

						{/* Components */}
						<div className="case-details-right-blocks">
							<TSAComponents caseDetails={caseDetails} caseIntraOp={caseIntraOp} operativeApproach={operativeApproach} operativeSide={operativeSide} />
						</div>
					</div>
				</div>

				{/* Comments */}
				<div className="case-details-container mt-0">
					<div className="case-details-center-blocks w-100">
						<Comments
							caseData={caseData}
							height={200}
							isReadOnlyNotes={isReadOnlyNotes}
							notesError={notesError}
							notesSaved={notesSaved}
							handleNotesInputChange={handleNotesInputChange}
							handleNoteSubmit={handleNoteSubmit}
							getUserRoleType={getUserRoleType}
							caseId={caseId}
						/>
					</div>
					{isLoading ? <div className="isLoading-overlay"><span>Saving...</span></div> : null}
				</div>
			</>
		)
	}
}
